import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";   // <— importación añadida
import App from "./App";
import Home from "./pages/Home";
import Servicios from "./pages/Servicios";
import Contacto from "./pages/Contacto";
import NotFound from "./pages/NotFound";
import "./index.css";
import EscuelaHipica from "./pages/EscuelaHipica";
import Cumpleanos from "./pages/Cumpleanos";
import { ScrollToTop } from "./components/ScrollToTop";
import Estabulacion from "./pages/Estabulacion";
import PonyClub from "./pages/PonyClub";
import CampamentoVerano from "./pages/CampamentoVerano";
import Instalaciones from "./pages/Instalaciones";
import VentaCaballos from "./pages/VentaCaballos";
import Concursos from "./pages/Concursos";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>       {/* <— envolvemos toda la app */}
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="servicios" element={<Servicios />} />
            <Route path="contacto" element={<Contacto />} />
            <Route path="escuela-hipica" element={<EscuelaHipica />} />
            <Route path="cumpleanos" element={<Cumpleanos />} />
            <Route path="estabulacion" element={<Estabulacion />} />
            <Route path="pony-club" element={<PonyClub />} />
            <Route path="campamento-verano" element={<CampamentoVerano />} />
            <Route path="instalaciones" element={<Instalaciones />} />
            <Route path="venta-caballos" element={<VentaCaballos />} />
            <Route path="concursos" element={<Concursos />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
